import React from 'react'
import { Redirect } from 'react-router-dom'
import { branch, renderComponent } from 'recompose'

const RedirectComponent = () => <Redirect to="/home" />

const withRedirectWhenEmpty = queryName =>
  branch(
    props => props.data[queryName] === null,
    renderComponent(RedirectComponent)
  )

export default withRedirectWhenEmpty



// WEBPACK FOOTER //
// ./src/hocs/withRedirectWhenEmpty.js